import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { CampaignsOverviewResponse } from 'src/services/__generated__/api'
import { UseGetCampaignsOverviewQueryParams } from './interfaces/useGetCampaignsOverviewQuery.interface'

const getCampaignsOverview = async (
  params: UseGetCampaignsOverviewQueryParams
): Promise<CampaignsOverviewResponse | undefined> => {
  if (!params.start || !params.end) return undefined

  const { data } = await AnalyticsApi.v1Private.campaignsOverviewList({
    campaignIds: params.campaignIds,
    fromDate: params.start,
    timezone: params.timezone,
    toDate: params.end,
  })

  return data
}

export const useGetCampaignsOverviewQuery = (
  params: UseGetCampaignsOverviewQueryParams
) => {
  return useQuery({
    enabled: Boolean(params.start && params.end),
    placeholderData: keepPreviousData,
    queryFn: () => getCampaignsOverview(params),
    queryKey: [
      QueryKey.GET_CAMPAIGNS_OVERVIEW,
      params.start,
      params.end,
      params.campaignIds,
      params.timezone,
    ],
  })
}
